export default {
  appName: 'Envío Qore',
  navigation: {
    reports: 'Informes',
    programs: 'Programas',
    dispatching: 'Despacho',
    management: 'Gestión',
    dashboard: 'Tablero',
    dispatchBoard: 'Tablero de despacho',
    dispatchControl: 'Control de despacho',
    customers: 'Clients',
    clients: 'Clientas',
    services: 'Servicios',
    dispatchWorkflows: 'Flujos de trabajo de despacho',
    settings: 'Settings',
    policyVerificationHistory: 'Verificación de políticas',
  }
};
